var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoiseAndOdors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.6,32.3c0.2,0,0.4,0,0.7,0c1.3,0,2.2-0.5,3.3-1.1c0.4-0.2,0.9-0.5,1.5-0.7c0.9,0.5,1.9,0.9,2.8,0.9 c0.3,0,0.7-0.1,1-0.2c2.6-1.1,2.9-3.4,2.9-5c0-2.3-2.4-5.1-4.4-7.7c-0.7-0.8-1.3-1.6-1.8-2.2c-1.9-2.7-4.6-6.4-6.8-8.2 c-0.4-0.3-1-0.3-1.4,0.1c-0.3,0.4-0.3,1,0.1,1.4c2.2,1.8,5.4,6.3,6.5,7.8c0.5,0.7,1.1,1.5,1.8,2.3c1.7,2,4,4.8,4,6.4 c0,1.8-0.5,2.7-1.7,3.3c-0.5,0.2-1.4-0.3-2.3-0.7c-0.1-0.1-0.2-0.1-0.4-0.2c0,0,0,0,0,0c-1.2-0.6-2.6-1.2-4.1-0.9 c-0.5,0.1-0.9,0.6-0.8,1.1c0.1,0.5,0.6,0.9,1.1,0.8c0.3-0.1,0.7,0,1,0c-1.1,0.6-1.8,1-2.7,0.8c-0.8-0.1-1.3-0.7-1.5-1 c-0.3-0.5-0.5-1-0.4-1.4c0.2-0.9,1.2-1.3,1.2-1.3c0.5-0.2,0.7-0.8,0.5-1.3c-0.2-0.5-0.8-0.7-1.3-0.5c-0.1,0-2,0.8-2.4,2.8 c-0.2,0.9,0.1,2,0.8,2.9C30.4,31.6,31.4,32.2,32.6,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.7,32.8c2.6,0,4.7-2.2,4.7-5c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1c0,1.7-1.2,3-2.7,3c-1.5,0-2.3-1-3.3-2.7 c-0.8-1.4-1.4-2.2-2.1-3.1c-0.4-0.5-0.9-1.2-1.5-2c-1.5-2.1-1.9-4.8-1.2-8c0.7-3,3.2-5.1,6.1-5.1c3,0,5.2,2.1,5.4,5.3 c0,0.5,0.5,0.9,1,0.9c0.5,0,0.9-0.5,0.9-1c-0.2-4.2-3.3-7.1-7.3-7.1c-3.8,0-7.1,2.7-8,6.6c-0.8,3.7-0.3,7,1.5,9.5 c0.6,0.9,1.1,1.5,1.5,2.1c0.7,0.9,1.2,1.6,2,2.9C18.4,30.4,19.8,32.8,22.7,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M24.1,18.9H25l0.1-0.7c0.1-1.8,0-4-1.4-5.5c-0.8-0.9-1.9-1.3-3.2-1.3c-1.4,0-2.6,0.6-3.5,1.7 c-1.4,1.8-1.7,4.5-1.3,6.3c0.1,0.5,0.6,0.8,1.2,0.7c0.5-0.1,0.8-0.6,0.7-1.2c-0.3-1.4-0.1-3.4,0.9-4.7c0.5-0.6,1.2-1,2-1 c0.8,0,1.4,0.2,1.8,0.7c0.6,0.7,1,1.9,0.9,3.5c-1.2,0.4-1.9,1.6-1.9,2.8c0,1.4,1,2.8,2.8,2.8c0.5,0,1-0.5,1-1s-0.4-1-1-1 c-0.9,0-0.9-0.9-0.9-1C23.2,20.1,23.2,18.9,24.1,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M3.6,28c0.2,0.2,0.4,0.2,0.6,0.2h0c0.3,0,0.6-0.2,0.8-0.5C5.1,27.4,5,27,4.7,26.8c-3.7-3.7-3.7-9.6,0-13.3 c0.3-0.3,0.3-0.8,0-1.2c-0.3-0.3-0.8-0.3-1.2,0C-0.7,16.7-0.7,23.7,3.6,28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M5.9,14.7c-3,3-3,8,0,11c0.2,0.2,0.4,0.2,0.6,0.2c0.3,0,0.6-0.2,0.8-0.5c0.1-0.3,0.1-0.7-0.2-0.9 c-2.4-2.4-2.4-6.3,0-8.7c0.3-0.3,0.3-0.8,0-1.2C6.7,14.3,6.2,14.3,5.9,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.5,17.8c0.3-0.3,0.3-0.8,0-1.2c-0.3-0.3-0.8-0.3-1.2,0c-1.9,1.9-1.9,5,0,6.9c0.2,0.2,0.4,0.2,0.6,0.2 c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6C8.2,21.2,8.2,19.1,9.5,17.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoiseAndOdors);
export default __webpack_public_path__ + "static/media/noise_and_odors.95f3d49ca1cdf391ba54e7f9c0587714.svg";
export { ForwardRef as ReactComponent };